import { render, staticRenderFns } from "./SideNavFooter.vue?vue&type=template&id=66143902&scoped=true&"
import script from "./SideNavFooter.vue?vue&type=script&lang=ts&"
export * from "./SideNavFooter.vue?vue&type=script&lang=ts&"
import style0 from "./SideNavFooter.vue?vue&type=style&index=0&id=66143902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66143902",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VLayout})
